import { render, staticRenderFns } from "./PPP3FormsNew.vue?vue&type=template&id=efd76ce4"
import script from "./PPP3FormsNew.vue?vue&type=script&lang=js"
export * from "./PPP3FormsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports